import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { CMSNavbarComponent } from "../navbar/CMSnavcomponent";
import ModuleModal from "./ModuleModal";
import { FullWidthBanners } from "./FullWidthBanners";
import { Banner } from "../../Pages";
import Settingsmodal from "./Settingsmodal";
import axiosConfig from "../../Service/axiosConfig";
import Select from "react-select";
import { useURLParams } from "../../Components/UrlUtils/useURLParams";
import { CategorySection } from "./CategorySection";
import { LuCopy, LuPencil } from "react-icons/lu";
import { toast } from "react-toastify";
import {
  MiddleBannerSection,
  OneByTwoSection,
  ProductSection,
  VerticalBannerSection,
  CategoryGroupingSection,
  FeaturedThisWeekSection,
} from ".";
// Read-only preview renderers for the collapsed/expanded card body.
// NOTE: adjust this import path to wherever these *View components live.
import {
  BannerView,
  CategorieView,
  CategoryGroupingView,
  FullWidthBannerView,
  MiddleBannerView,
  OneByTwoView,
  ProductSectionView,
  VerticalBannerView,
  FeaturedThisWeekView,
} from ".";
import "./HomePagedesignCSS.css";


function Homedesign() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [moduleButtons, setModuleButtons] = useState([]);
  const { setParam, getParam } = useURLParams();
  const [loading, setLoading] = useState(true);
  const [id, setid] = useState();
  const [show, setShow] = useState(false);
  const [counter, setCounter] = useState(1);

  // UI-only state: which section's editor is open. Only one at a time.
  const [expandedSection, setExpandedSection] = useState(null);

  const handleShow = () => setShow(true);
  const [homepageOptions, SethomepageOptions] = useState([]);

  const [selectedhomepageId, setSelectedhomepageId] = useState(
    getParam("home_page_id") || ""
  );

  const openModal = (id) => {
    setModalIsOpen(true);
    setid(id);
  };

  const addNewModule = () => {
    const existingIds = moduleButtons
      .map((module) => module.id)
      .filter((id) => id);
    const newId = existingIds.length > 0 ? Math.max(...existingIds) + 1 : 1;

    const newSortValue = moduleButtons.length + 1;
    const newModule = { id: newId, component: null, sort: newSortValue };

    setModuleButtons((prevModules) => [...prevModules, newModule]);
  };

  const addNewComponent = (id, type) => {
    setModuleButtons((prevModules) =>
      prevModules.map((module) =>
        module.id === id ? { ...module, component: type, data: {} } : module
      )
    );
  };

  useEffect(() => {
    const fetchhomepagename = async () => {
      try {
        let response = await axiosConfig.get(
          "/cms/homepage_name/?page_size=50&is_suspended=false"
        );
        SethomepageOptions(
          response.data.results.map((homepage) => ({
            value: homepage.id,
            label: homepage.home_page_name,
          }))
        );
      } catch (error) {
        console.error("Error fetching homepage Name:", error);
        SethomepageOptions([]);
      }
    };

    fetchhomepagename();
  }, []);

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const reorderedModules = [...moduleButtons];
    const [movedItem] = reorderedModules.splice(result.source.index, 1);
    reorderedModules.splice(result.destination.index, 0, movedItem);
    const orderedModules = reorderedModules.map((module, index) => ({
      ...module,
      sort: index + 1,
    }));

    setModuleButtons(orderedModules);

    try {
      for (let module of orderedModules) {
        if (module.id) {
          await axiosConfig.patch(`/cms/homepage_template/${module.id}/`, {
            sort: module.sort,
          });
        }
      }
      // Ensure UI perfectly matches backend after patch loop completes
      getTemplate();
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handlehomepageFilterChange = (e) => {
    setSelectedhomepageId(e.value);
    setParam("home_page_id", e.value);
  };

  const clearSelection = () => {
    setSelectedhomepageId("");
    setParam("home_page_id", "");
  };

  const selectedOption =
    (homepageOptions &&
      homepageOptions.find(
        (option) => option.value === parseFloat(selectedhomepageId)
      )) ||
    null;

  const getTemplate = async () => {
    try {
      if (selectedhomepageId) {
        const response = await axiosConfig.get(
          `/cms/homepage_template/?home_page__id=${selectedhomepageId}`
        );

        if (response.data && response.data.results) {
          // Helper to build the shared visibility/sort fields for any module
          const buildCommonFields = (template) => ({
            sort: template.sort,
            is_suspended: template.is_suspended,
            show_banner: template.show_banner ?? true,
            show_slider: template.show_slider ?? true,
            show_category: template.show_category ?? true,
            show_subcategory: template.show_subcategory ?? true,
            show_vertical_banners: template.show_vertical_banners ?? true,
            show_middle_banners: template.show_middle_banners ?? true,
            show_onebytwo_banners: template.show_onebytwo_banners ?? true,
            show_promotional_category: template.show_promotional_category ?? true,
            show_category_grouping: template.show_category_grouping ?? true,
          });

          // flatMap so one template with e.g. both banner + category_grouping
          // correctly expands into two separate section-card modules.
          const savedModules = response.data.results.flatMap((template) => {
            const modules = [];

            const isFeaturedThisWeek =
              (template.title || "").toLowerCase().includes("featured");

            // ── Banners / Featured This Week ──────────────────────────────
            if (template.banner?.length > 0) {
              const banners = template.banner.map((banner) => ({
                ...banner,
                image: banner?.image__image || banner?.image?.image || banner?.image,
                image__image: banner?.image__image || banner?.image?.image || banner?.image,
                subcategory: banner?.subcategory?.name || banner?.subcategory__name || banner?.name,
                template_id: banner?.template_id || template.id,
              }));
              modules.push({
                id: template.id,
                component: isFeaturedThisWeek ? "Featured This Week" : "Full Width Banner",
                data: { banners, sliders: [], categories: [], products: [], vertical_banner: [], middle_banner: [], onebytwo_banner: [], category_grouping: [], featured_this_week: banners },
                bannerSecId: banners[0]?.template_id || template.id,
                sliderSecId: null,
                categorySecId: template.id,
                productSecId: null,
                vertical_bannerSecId: null,
                middle_bannerSecId: null,
                onebytwo_bannerSecId: null,
                categoryGroupingSecId: null,
                featured_this_weekSecId: isFeaturedThisWeek ? (banners[0]?.template_id || template.id) : null,
                ...buildCommonFields(template),
              });
            }

            // ── Sliders ───────────────────────────────────────────────────
            if (template.slider?.length > 0) {
              const sliders = template.slider.map((slider) => ({
                ...slider,
                image: slider?.image__image || slider?.image?.image || slider?.image,
                image__image: slider?.image__image || slider?.image?.image || slider?.image,
                subcategory: slider?.subcategory?.name || slider?.subcategory__name || slider?.name,
                template_id: slider?.template_id || template.id,
              }));
              modules.push({
                id: template.id,
                component: "Banner Slider",
                data: { banners: [], sliders, categories: [], products: [], vertical_banner: [], middle_banner: [], onebytwo_banner: [], category_grouping: [], featured_this_week: [] },
                bannerSecId: null,
                sliderSecId: sliders[0]?.template_id || template.id,
                categorySecId: template.id,
                productSecId: null,
                vertical_bannerSecId: null,
                middle_bannerSecId: null,
                onebytwo_bannerSecId: null,
                categoryGroupingSecId: null,
                featured_this_weekSecId: null,
                ...buildCommonFields(template),
              });
            }

            // ── Categories ────────────────────────────────────────────────
            if (template.category?.length > 0) {
              const categories = template.category.map((categorie) => ({
                ...categorie,
                image: categorie?.image__image || categorie?.image?.image || categorie?.image,
                image__image: categorie?.image__image || categorie?.image?.image || categorie?.image,
                name: categorie?.name || categorie?.subcategory?.name,
                subcategory: categorie?.subcategory?.name || categorie?.name,
                template_id: categorie?.template_id || template.id,
              }));
              modules.push({
                id: template.id,
                component: "Categorie",
                data: { banners: [], sliders: [], categories, products: [], vertical_banner: [], middle_banner: [], onebytwo_banner: [], category_grouping: [], featured_this_week: [] },
                bannerSecId: null,
                sliderSecId: null,
                categorySecId: template.id,
                productSecId: null,
                vertical_bannerSecId: null,
                middle_bannerSecId: null,
                onebytwo_bannerSecId: null,
                categoryGroupingSecId: null,
                featured_this_weekSecId: null,
                ...buildCommonFields(template),
              });
            }

            // ── Products / Subcategory ────────────────────────────────────
            if (template.subcategory?.length > 0) {
              const products = template.subcategory.map((sub) => ({
                ...sub,
                image: sub?.image__image || sub?.subcategory?.image?.image || sub?.promotional_category?.image?.image || sub?.image,
                image__image: sub?.image__image || sub?.subcategory?.image?.image || sub?.promotional_category?.image?.image || sub?.image,
                name: sub?.name || sub?.subcategory?.name || sub?.promotional_category?.title,
                subcategory: sub?.subcategory?.name || sub?.promotional_category?.title || sub?.name,
                sub_id: sub?.sub_id || sub?.subcategory?.id || sub?.subcategory,
                sub_slug: sub?.sub_slug || sub?.subcategory?.sub_slug,
                template_id: sub?.template_id || template.id,
              }));
              modules.push({
                id: template.id,
                component: "Products",
                data: { banners: [], sliders: [], categories: [], products, vertical_banner: [], middle_banner: [], onebytwo_banner: [], category_grouping: [], featured_this_week: [] },
                bannerSecId: null,
                sliderSecId: null,
                categorySecId: template.id,
                productSecId: products[0]?.template_id || template.id,
                vertical_bannerSecId: null,
                middle_bannerSecId: null,
                onebytwo_bannerSecId: null,
                categoryGroupingSecId: null,
                featured_this_weekSecId: null,
                ...buildCommonFields(template),
              });
            }

            // ── Vertical Banners ──────────────────────────────────────────
            if (template.vertical_banners?.length > 0) {
              const vertical_banner = template.vertical_banners.map((v) => ({
                id: v.id,
                image: v?.image__image || v?.image?.image || v?.image,
                image__image: v?.image__image || v?.image?.image || v?.image,
                subcategory: v?.name,
                template_id: v?.template_id || template.id,
              }));
              modules.push({
                id: template.id,
                component: "Vertical Banners",
                data: { banners: [], sliders: [], categories: [], products: [], vertical_banner, middle_banner: [], onebytwo_banner: [], category_grouping: [], featured_this_week: [] },
                bannerSecId: null,
                sliderSecId: null,
                categorySecId: template.id,
                productSecId: null,
                vertical_bannerSecId: vertical_banner[0]?.template_id || template.id,
                middle_bannerSecId: null,
                onebytwo_bannerSecId: null,
                categoryGroupingSecId: null,
                featured_this_weekSecId: null,
                ...buildCommonFields(template),
              });
            }

            // ── Middle Banners ────────────────────────────────────────────
            if (template.middle_banners?.length > 0) {
              const middle_banner = template.middle_banners.map((m) => ({
                id: m.id,
                image: m?.image__image || m?.image?.image || m?.image,
                image__image: m?.image__image || m?.image?.image || m?.image,
                subcategory: m?.name,
                template_id: m?.template_id || template.id,
              }));
              modules.push({
                id: template.id,
                component: "Middle Banners",
                data: { banners: [], sliders: [], categories: [], products: [], vertical_banner: [], middle_banner, onebytwo_banner: [], category_grouping: [], featured_this_week: [] },
                bannerSecId: null,
                sliderSecId: null,
                categorySecId: template.id,
                productSecId: null,
                vertical_bannerSecId: null,
                middle_bannerSecId: middle_banner[0]?.template_id || template.id,
                onebytwo_bannerSecId: null,
                categoryGroupingSecId: null,
                featured_this_weekSecId: null,
                ...buildCommonFields(template),
              });
            }

            // ── One By Two Banners ────────────────────────────────────────
            if (template.onebytwo_banners?.length > 0) {
              const onebytwo_banner = template.onebytwo_banners.map((o) => ({
                id: o.id,
                image: o?.image__image || o?.image?.image || o?.image,
                image__image: o?.image__image || o?.image?.image || o?.image,
                subcategory: o?.name,
                template_id: o?.template_id || template.id,
              }));
              modules.push({
                id: template.id,
                component: "One By Two Banners",
                data: { banners: [], sliders: [], categories: [], products: [], vertical_banner: [], middle_banner: [], onebytwo_banner, category_grouping: [], featured_this_week: [] },
                bannerSecId: null,
                sliderSecId: null,
                categorySecId: template.id,
                productSecId: null,
                vertical_bannerSecId: null,
                middle_bannerSecId: null,
                onebytwo_bannerSecId: onebytwo_banner[0]?.template_id || template.id,
                categoryGroupingSecId: null,
                featured_this_weekSecId: null,
                ...buildCommonFields(template),
              });
            }

            // ── Category Grouping ─────────────────────────────────────────
            const category_grouping = (template.category_grouping || [])
              .filter((grp) => typeof grp === "object" && !grp.is_suspended);
            if (category_grouping.length > 0) {
              modules.push({
                id: template.id,
                component: "Category Grouping",
                data: { banners: [], sliders: [], categories: [], products: [], vertical_banner: [], middle_banner: [], onebytwo_banner: [], category_grouping, featured_this_week: [] },
                bannerSecId: null,
                sliderSecId: null,
                categorySecId: template.id,
                productSecId: null,
                vertical_bannerSecId: null,
                middle_bannerSecId: null,
                onebytwo_bannerSecId: null,
                categoryGroupingSecId: template.id,
                featured_this_weekSecId: null,
                ...buildCommonFields(template),
              });
            }

            return modules;
          });

          // Ensure the array is strictly sorted by the `sort` value before rendering
          savedModules.sort((a, b) => (a.sort || 0) - (b.sort || 0));
          setModuleButtons(savedModules);
          setCounter(savedModules.length + 1);
        }
      }
    } catch (error) {
      console.error("Error fetching or saving template data:", error);
    }
  };

  useEffect(() => {
    getTemplate();
  }, [selectedhomepageId]);

  const handleMoveModule = async (index, direction) => {
    if (
      (direction === "up" && index === 0) ||
      (direction === "down" && index === moduleButtons.length - 1)
    ) {
      return;
    }

    const reorderedModules = [...moduleButtons];
    const newIndex = direction === "up" ? index - 1 : index + 1;

    const temp = reorderedModules[index];
    reorderedModules[index] = reorderedModules[newIndex];
    reorderedModules[newIndex] = temp;

    const orderedModules = reorderedModules.map((module, idx) => ({
      ...module,
      sort: idx + 1,
    }));

    setModuleButtons(orderedModules);

    try {
      for (let module of orderedModules) {
        if (module.id) {
          await axiosConfig.patch(`/cms/homepage_template/${module.id}/`, {
            sort: module.sort,
          });
        }
      }
      // Refresh to ensure exact synchronization with the backend
      getTemplate();
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handleDuplicateModule = (index, component) => {
    const existingIds = moduleButtons
      .map((module) => module.id)
      .filter((id) => id);
    const newId = existingIds.length > 0 ? Math.max(...existingIds) + 1 : 1;

    const newModule = {
      id: newId,
      component: component,
      data: {}
    };

    const reorderedModules = [...moduleButtons];
    reorderedModules.splice(index + 1, 0, newModule);

    const orderedModules = reorderedModules.map((module, idx) => ({
      ...module,
      sort: idx + 1,
    }));

    setModuleButtons(orderedModules);
    toast.success("Section duplicated successfully");
  };

  // Toggle accordion edit state — opening one closes any other.
  const toggleEdit = (moduleId) => {
    setExpandedSection((prev) => (prev === moduleId ? null : moduleId));
  };

  // Maps a section component name to its API visibility flag key.
  const getVisibilityFlag = (component) =>
    ({
      "Full Width Banner":  "show_banner",
      "Featured This Week": "show_banner",
      "Banner Slider":       "show_slider",
      "Categorie":           "show_category",
      "Category Grouping":   "show_category_grouping",
      "Products":            "show_subcategory",
      "Vertical Banners":    "show_vertical_banners",
      "Middle Banners":      "show_middle_banners",
      "One By Two Banners":  "show_onebytwo_banners",
    }[component] || null);

  // Toggle visibility via PATCH, optimistic UI with rollback on error.
  const handleVisibilityToggle = async (module) => {
    const flagKey = getVisibilityFlag(module.component);
    if (!flagKey) return;

    const newValue = !module[flagKey];

    // Optimistic update
    setModuleButtons((prev) =>
      prev.map((m) =>
        m.id === module.id ? { ...m, [flagKey]: newValue } : m
      )
    );

    try {
      await axiosConfig.patch(`/cms/homepage_template/${module.id}/`, {
        [flagKey]: newValue,
      });
    } catch (err) {
      console.error("Failed to update visibility:", err);
      // Rollback
      setModuleButtons((prev) =>
        prev.map((m) =>
          m.id === module.id ? { ...m, [flagKey]: !newValue } : m
        )
      );
      toast.error("Failed to update visibility. Please try again.");
    }
  };

  // Existing delete functionality — adjust endpoint/method to match your API if different.
  const handleDeleteModule = async (moduleId) => {
    if (!window.confirm("Delete this section? This cannot be undone.")) return;
    try {
      await axiosConfig.delete(`/cms/homepage_template/${moduleId}/`);
      setModuleButtons((prev) => prev.filter((m) => m.id !== moduleId));
      if (expandedSection === moduleId) setExpandedSection(null);
    } catch (error) {
      console.error("Error deleting section:", error);
    }
  };

  // Read-only preview shown inside every card (collapsed and expanded).
  const renderPreview = (module) => {
    switch (module.component) {
      case "Full Width Banner":
        return <FullWidthBannerView data={module.data?.banners || []} />;
      case "Banner Slider":
        return <BannerView data={module.data?.sliders || []} />;
      case "Categorie":
        return <CategorieView data={module.data?.categories || []} />;
      case "Products":
        return <ProductSectionView data={module.data?.products || []} />;
      case "Vertical Banners":
        return <VerticalBannerView data={module.data?.vertical_banner || []} />;
      case "Middle Banners":
        return <MiddleBannerView data={module.data?.middle_banner || []} />;
      case "One By Two Banners":
        return <OneByTwoView data={module.data?.onebytwo_banner || []} />;
      case "Category Grouping":
        return <CategoryGroupingView data={module.data?.category_grouping || []} />;
      case "Featured This Week":
        return <FeaturedThisWeekView data={module.data?.banners || []} />;
      default:
        return (
          <div className="section-preview-empty">No preview available</div>
        );
    }
  };

  // Existing editors — same props as before, untouched logic.
  const renderEditor = (module) => {
    switch (module.component) {
      case "Full Width Banner":
        return (
          <FullWidthBanners
            id={module.id}
            data={module.data}
            bannerSecId={module.bannerSecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "Banner Slider":
        return (
          <Banner
            id={module.id}
            data={module.data}
            is_suspended={module.is_suspended}
            sliderSecId={module.sliderSecId}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "Categorie":
        return (
          <CategorySection
            id={module.id}
            data={module.data}
            categorySecId={module.categorySecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "Products":
        return (
          <ProductSection
            id={module.id}
            data={module.data}
            productSecId={module.productSecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "Vertical Banners":
        return (
          <VerticalBannerSection
            id={module.id}
            data={module.data}
            vertical_bannerSecId={module.vertical_bannerSecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "Middle Banners":
        return (
          <MiddleBannerSection
            id={module.id}
            data={module.data}
            middle_bannerSecId={module.middle_bannerSecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "One By Two Banners":
        return (
          <OneByTwoSection
            id={module.id}
            data={module.data}
            onebytwo_bannerSecId={module.onebytwo_bannerSecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "Category Grouping":
        return (
          <CategoryGroupingSection
            id={module.id}
            data={module.data}
            categoryGroupingSecId={module.categoryGroupingSecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      case "Featured This Week":
        return (
          <FeaturedThisWeekSection
            id={module.id}
            data={module.data}
            bannerSecId={module.bannerSecId}
            is_suspended={module.is_suspended}
            selectedhomepageId={selectedhomepageId}
            getTemplate={getTemplate}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="child-sidenav">
      <CMSNavbarComponent handleShow={handleShow} />
      <div className="childnav-content">
        <div className="col-md-4 sub-filter mt-3">
          <Select
            options={homepageOptions}
            placeholder={selectedhomepageId ? "" : "Select Homepage Name"}
            value={selectedOption}
            onChange={(selectedOption) => {
              if (!selectedOption) {
                clearSelection();
              } else {
                handlehomepageFilterChange(selectedOption);
              }
            }}
            isClearable
            required
          />
        </div>

        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="modules">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="section-accordion-list"
              >
                <AnimatePresence>
                  {moduleButtons.map((module, index) => (
                    <Draggable
                      key={module.id}
                      draggableId={module.id.toString()}
                      index={index}
                    >
                      {(dragProvided, snapshot) => (
                        <motion.div
                          layout={!snapshot.isDragging ? "position" : false}
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, scale: 0.97 }}
                          transition={{
                            layout: { duration: 0.45, ease: [0.4, 0, 0.2, 1] },
                            opacity: { duration: 0.2 },
                          }}
                          ref={dragProvided.innerRef}
                          {...dragProvided.draggableProps}
                          className={`section-card ${expandedSection === module.id ? "is-expanded" : ""} ${snapshot.isDragging ? "is-dragging" : ""} ${getVisibilityFlag(module.component) && !module[getVisibilityFlag(module.component)] ? "is-hidden-section" : ""}`}
                        >
                          {module.component ? (
                            <>
                              <div className="section-card-header">
                                <div className="section-card-title">
                                  <span
                                    {...dragProvided.dragHandleProps}
                                    className="drag-handle"
                                    title="Drag to reorder"
                                  >
                                    ⠿
                                  </span>
                                  <span className="section-index">
                                    Section {index + 1}
                                  </span>
                                  <span className="section-type">
                                    {module.component}
                                  </span>
                                </div>

                                <div className="section-card-actions">
                                  <button
                                    type="button"
                                    className="icon-btn"
                                    title="Move up"
                                    disabled={index === 0}
                                    style={{ opacity: index === 0 ? 0.3 : 1, cursor: index === 0 ? "not-allowed" : "pointer" }}
                                    onClick={() => handleMoveModule(index, "up")}
                                  >
                                    <svg
                                      width="17"
                                      height="17"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1.8"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <path d="M12 19V5" />
                                      <path d="M5 12l7-7 7 7" />
                                    </svg>
                                  </button>
                                  <button
                                    type="button"
                                    className="icon-btn"
                                    title="Move down"
                                    disabled={index === moduleButtons.length - 1}
                                    style={{ opacity: index === moduleButtons.length - 1 ? 0.3 : 1, cursor: index === moduleButtons.length - 1 ? "not-allowed" : "pointer" }}
                                    onClick={() => handleMoveModule(index, "down")}
                                  >
                                    <svg
                                      width="17"
                                      height="17"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1.8"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <path d="M12 5v14" />
                                      <path d="M19 12l-7 7-7-7" />
                                    </svg>
                                  </button>
                                  <button
                                    type="button"
                                    className="icon-btn"
                                    title="Duplicate section"
                                    onClick={() => handleDuplicateModule(index, module.component)}
                                  >
                                    <LuCopy size={17} />
                                  </button>
                                  <button
                                    type="button"
                                    className={`icon-btn ${expandedSection === module.id
                                      ? "icon-btn-active"
                                      : ""
                                      }`}
                                    title={
                                      expandedSection === module.id
                                        ? "Close editor"
                                        : "Edit section"
                                    }
                                    onClick={() => toggleEdit(module.id)}
                                  >
                                    <LuPencil size={17} />
                                  </button>
                                   <button
                                     type="button"
                                     className={`icon-btn visibility-toggle ${getVisibilityFlag(module.component) && module[getVisibilityFlag(module.component)] === false ? "visibility-hidden" : "visibility-visible"}`}
                                     title={getVisibilityFlag(module.component) && module[getVisibilityFlag(module.component)] === false ? "Hidden on frontend — click to show" : "Visible on frontend — click to hide"}
                                     onClick={() => handleVisibilityToggle(module)}
                                     onMouseDown={(e) => e.stopPropagation()}
                                     style={{ display: getVisibilityFlag(module.component) ? "flex" : "none" }}
                                   >
                                     {getVisibilityFlag(module.component) && module[getVisibilityFlag(module.component)] === false ? (
                                       /* Eye-off SVG — hidden state */
                                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                         <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                                         <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                                         <line x1="1" y1="1" x2="23" y2="23" />
                                       </svg>
                                     ) : (
                                       /* Eye SVG — visible state */
                                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                         <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                         <circle cx="12" cy="12" r="3" />
                                       </svg>
                                     )}
                                   </button>
                                  <button
                                    type="button"
                                    className="icon-btn icon-btn-danger"
                                    title="Delete section"
                                    onClick={() => handleDeleteModule(module.id)}
                                  >
                                    <svg
                                      width="17"
                                      height="17"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1.8"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <path d="M3 6h18" />
                                      <path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
                                      <path d="M19 6l-1 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1L5 6" />
                                      <path d="M10 11v6" />
                                      <path d="M14 11v6" />
                                    </svg>
                                  </button>
                                </div>
                              </div>

                              {expandedSection === module.id && (
                                <div className="section-card-editor">
                                  {renderEditor(module)}
                                  <div className="section-card-preview-label">
                                    Preview
                                  </div>
                                  <div className="section-card-preview">
                                    {renderPreview(module)}
                                  </div>
                                </div>
                              )}

                              {expandedSection !== module.id && (
                                <div className="section-card-preview section-card-preview-collapsed">
                                  {renderPreview(module)}
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="btn-add-module">
                              <button
                                className="btn btn-primary"
                                onClick={() => openModal(module.id)}
                              >
                                Add Module
                              </button>
                            </div>
                          )}
                        </motion.div>
                      )}
                    </Draggable>
                  ))}
                </AnimatePresence>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <div className="text-center cursor-pointer" onClick={addNewModule}>
          <p className="text-decoration-underline py-4 add-section">
            + Add New Section
          </p>
        </div>
      </div>

      {modalIsOpen && (
        <ModuleModal
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          addNewComponent={addNewComponent}
          id={id}
        />
      )}
      {show && <Settingsmodal show={show} setShow={setShow} />}
    </div>
  );
}

export { Homedesign };